module.exports = __webpack_public_path__ + "images/emoji/scroll.97715a12c830cc8b062e.png";